import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, vShow as _vShow, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "editor-modal" };
const _hoisted_2 = { class: "modal-header" };
const _hoisted_3 = { class: "modal-title-row" };
const _hoisted_4 = { class: "modal-emoji" };
const _hoisted_5 = { class: "modal-title" };
const _hoisted_6 = { class: "locale-tabs" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
    key: 0,
    class: "saved-dot",
    title: "Configuré"
};
const _hoisted_9 = { class: "editor-body" };
const _hoisted_10 = { class: "editor-form" };
const _hoisted_11 = { class: "form-section" };
const _hoisted_12 = { class: "branding-row" };
const _hoisted_13 = {
    class: "field-group",
    style: { "position": "relative", "z-index": "50" }
};
const _hoisted_14 = { style: { "display": "flex", "gap": "8px" } };
const _hoisted_15 = {
    key: 0,
    class: "gallery-popup"
};
const _hoisted_16 = { class: "gallery-popup-header" };
const _hoisted_17 = {
    key: 0,
    class: "gallery-empty"
};
const _hoisted_18 = {
    key: 1,
    class: "gallery-popup-grid"
};
const _hoisted_19 = ["src", "onClick"];
const _hoisted_20 = { class: "field-group field-group-sm" };
const _hoisted_21 = { class: "color-input-row" };
const _hoisted_22 = { class: "form-section" };
const _hoisted_23 = { class: "field-group" };
const _hoisted_24 = ["placeholder"];
const _hoisted_25 = { class: "form-section" };
const _hoisted_26 = { class: "variables-list" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "form-section editor-section" };
const _hoisted_29 = { class: "field-label-row" };
const _hoisted_30 = { class: "d-flex align-items-center gap-2" };
const _hoisted_31 = { class: "relative-container" };
const _hoisted_32 = {
    key: 0,
    class: "cta-url-overlay"
};
const _hoisted_33 = { class: "cta-url-card" };
const _hoisted_34 = { class: "cta-field" };
const _hoisted_35 = { class: "cta-field" };
const _hoisted_36 = { class: "cta-design-grid" };
const _hoisted_37 = { class: "cta-field" };
const _hoisted_38 = { class: "cta-color-picker" };
const _hoisted_39 = { class: "cta-presets" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = { class: "cta-field" };
const _hoisted_42 = { class: "cta-toggle-group" };
const _hoisted_43 = { class: "cta-field" };
const _hoisted_44 = { class: "cta-toggle-group" };
const _hoisted_45 = { class: "cta-variables" };
const _hoisted_46 = ["onClick"];
const _hoisted_47 = { class: "cta-actions" };
const _hoisted_48 = {
    key: 0,
    class: "raw-html-editor"
};
const _hoisted_49 = { class: "raw-editor-header" };
const _hoisted_50 = { class: "editor-preview" };
const _hoisted_51 = { class: "preview-header" };
const _hoisted_52 = ["disabled"];
const _hoisted_53 = { class: "gmail-window" };
const _hoisted_54 = { class: "gmail-email-header" };
const _hoisted_55 = { class: "gmail-subject" };
const _hoisted_56 = { class: "gmail-body-wrapper" };
const _hoisted_57 = ["srcdoc"];
const _hoisted_58 = {
    key: 1,
    class: "preview-placeholder"
};
const _hoisted_59 = { class: "modal-footer" };
const _hoisted_60 = { class: "footer-actions-left" };
const _hoisted_61 = {
    key: 1,
    class: "reset-confirm-group"
};
const _hoisted_62 = { class: "footer-actions-right" };
const _hoisted_63 = ["disabled"];
const _hoisted_64 = ["disabled"];
const _hoisted_65 = {
    key: 0,
    class: "btn-spinner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    return (_openBlock(), _createElementBlock("div", {
        class: "editor-overlay",
        onClick: _cache[28] || (_cache[28] = _withModifiers(($event) => (_ctx.$emit('close')), ["self"]))
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getTemplateEmoji(_ctx.templateMeta.key)), 1),
                    _createElementVNode("div", null, [
                        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.getTemplateName(_ctx.templateMeta.key)), 1),
                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "modal-subtitle" }, "Configurez le template par langue et personnalisez votre marque", -1))
                    ])
                ]),
                _createElementVNode("button", {
                    class: "close-btn",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                }, "✕")
            ]),
            _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (loc) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: loc.code,
                        class: _normalizeClass(['locale-tab', { active: _ctx.activeLocale === loc.code }]),
                        onClick: ($event) => (_ctx.switchLocale(loc.code))
                    }, [
                        _createElementVNode("span", null, _toDisplayString(loc.flag), 1),
                        _createElementVNode("span", null, _toDisplayString(loc.label), 1),
                        (_ctx.isSavedLocale(loc.code))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                            : _createCommentVNode("", true)
                    ], 10, _hoisted_7));
                }), 128))
            ]),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "section-title" }, "🎨 Identité Visuelle", -1)),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "field-label" }, "URL du Logo", -1)),
                                _createElementVNode("div", _hoisted_14, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.logo_url) = $event)),
                                        class: "field-input",
                                        placeholder: "https://votre-cdn.com/logo.png"
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.logo_url]
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-gallery",
                                        onClick: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => (_ctx.toggleGallery && _ctx.toggleGallery(...args)))
                                    }, "Galerie")
                                ]),
                                (_ctx.showGallery)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            _cache[30] || (_cache[30] = _createElementVNode("span", null, "Choisissez une image", -1)),
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showGallery = false)),
                                                class: "gallery-close"
                                            }, "×")
                                        ]),
                                        (_ctx.galleryImages.length === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Aucune image disponible ou chargement... "))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryImages, (img) => {
                                                    return (_openBlock(), _createElementBlock("img", {
                                                        key: img.id,
                                                        src: img.imageUrl,
                                                        onClick: ($event) => (_ctx.selectImage(img.imageUrl)),
                                                        class: "gallery-popup-img",
                                                        title: "Choisir cette image"
                                                    }, null, 8, _hoisted_19));
                                                }), 128))
                                            ]))
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "field-label" }, "Couleur Principale", -1)),
                                _createElementVNode("div", _hoisted_21, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "color",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.form.primary_color) = $event)),
                                        class: "color-picker"
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.primary_color]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.form.primary_color) = $event)),
                                        class: "field-input",
                                        placeholder: "#c8a96e"
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.primary_color]
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _cache[34] || (_cache[34] = _createElementVNode("label", { class: "field-label" }, "Objet de l'email", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.subject) = $event)),
                                class: "field-input",
                                placeholder: `Objet pour ${_ctx.activeLocale.toUpperCase()}`
                            }, null, 8, _hoisted_24), [
                                [_vModelText, _ctx.form.subject]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                        _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "section-title" }, "🔧 Variables disponibles", -1)),
                        _createElementVNode("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateMeta.variables, (v) => {
                                return (_openBlock(), _createElementBlock("span", {
                                    key: v,
                                    class: "variable-chip",
                                    onClick: ($event) => (_ctx.copyVariable(v)),
                                    title: 'Cliquer pour copier'
                                }, _toDisplayString(_ctx.formatVariable(v)), 9, _hoisted_27));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "field-label" }, "Corps de l'email", -1)),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn-expert-mode", { active: _ctx.showRawHtml }]),
                                    onClick: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => (_ctx.toggleExpertMode && _ctx.toggleExpertMode(...args)))
                                }, [
                                    _cache[36] || (_cache[36] = _createElementVNode("i", { class: "ri-code-s-slash-line" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.showRawHtml ? 'Mode Visuel' : 'Mode Expert (HTML)'), 1)
                                ], 2)
                            ]),
                            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "hint-text" }, "Utilisez les variables ci-dessus pour personnaliser", -1))
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_QuillEditor, {
                                ref: "quillEditorRef",
                                theme: "snow",
                                options: _ctx.editorOptions,
                                onReady: _ctx.handleEditorReady,
                                onTextChange: _ctx.onEditorChange
                            }, null, 8, ["options", "onReady", "onTextChange"]),
                            (_ctx.showCtaModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _cache[44] || (_cache[44] = _createElementVNode("h6", null, "🔗 Configuration du bouton", -1)),
                                        _createElementVNode("div", _hoisted_34, [
                                            _cache[39] || (_cache[39] = _createElementVNode("label", null, "Texte du bouton", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.ctaText) = $event)),
                                                placeholder: "Ex: Activer mon compte",
                                                class: "cta-input"
                                            }, null, 512), [
                                                [_vModelText, _ctx.ctaText]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                            _cache[40] || (_cache[40] = _createElementVNode("label", null, "Lien (URL)", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.ctaUrl) = $event)),
                                                placeholder: "https://... ou {{variable}}",
                                                class: "cta-input",
                                                ref: "ctaInputRef",
                                                onKeyup: _cache[10] || (_cache[10] = _withKeys(
                                                //@ts-ignore
                                                (...args) => (_ctx.applyCta && _ctx.applyCta(...args)), ["enter"]))
                                            }, null, 544), [
                                                [_vModelText, _ctx.ctaUrl]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("div", _hoisted_37, [
                                                _cache[41] || (_cache[41] = _createElementVNode("label", null, "Couleur fond", -1)),
                                                _createElementVNode("div", _hoisted_38, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "color",
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.ctaBgColor) = $event)),
                                                        class: "cta-color-input"
                                                    }, null, 512), [
                                                        [_vModelText, _ctx.ctaBgColor]
                                                    ]),
                                                    _createElementVNode("div", _hoisted_39, [
                                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['#c8a96e', '#111122', '#dc3545', '#28a745'], (c) => {
                                                            return _createElementVNode("button", {
                                                                key: c,
                                                                style: _normalizeStyle({ background: c }),
                                                                class: "preset-btn",
                                                                onClick: ($event) => (_ctx.ctaBgColor = c)
                                                            }, null, 12, _hoisted_40);
                                                        }), 64))
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_41, [
                                                _cache[42] || (_cache[42] = _createElementVNode("label", null, "Forme (Arrondi)", -1)),
                                                _createElementVNode("div", _hoisted_42, [
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass({ active: _ctx.ctaRadius === '0px' }),
                                                        onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.ctaRadius = '0px'))
                                                    }, "Carré", 2),
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass({ active: _ctx.ctaRadius === '8px' }),
                                                        onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.ctaRadius = '8px'))
                                                    }, "Demi", 2),
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass({ active: _ctx.ctaRadius === '40px' }),
                                                        onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.ctaRadius = '40px'))
                                                    }, "Rond", 2)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_43, [
                                                _cache[43] || (_cache[43] = _createElementVNode("label", null, "Bordure", -1)),
                                                _createElementVNode("div", _hoisted_44, [
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass({ active: !_ctx.ctaHasBorder }),
                                                        onClick: _cache[15] || (_cache[15] = ($event) => (_ctx.ctaHasBorder = false))
                                                    }, "Sans", 2),
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass({ active: _ctx.ctaHasBorder }),
                                                        onClick: _cache[16] || (_cache[16] = ($event) => (_ctx.ctaHasBorder = true))
                                                    }, "Ligne", 2)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_45, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateMeta.variables, (v) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: v,
                                                    class: "cta-var-chip",
                                                    onClick: ($event) => (_ctx.ctaUrl = `{{${v}}}`)
                                                }, _toDisplayString(v), 9, _hoisted_46));
                                            }), 128))
                                        ]),
                                        _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("button", {
                                                class: "btn-cta-cancel",
                                                onClick: _cache[17] || (_cache[17] = ($event) => (_ctx.showCtaModal = false))
                                            }, "Annuler"),
                                            _createElementVNode("button", {
                                                class: "btn-cta-apply",
                                                onClick: _cache[18] || (_cache[18] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.applyCta && _ctx.applyCta(...args)))
                                            }, "Appliquer")
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ], 512), [
                            [_vShow, !_ctx.showRawHtml]
                        ]),
                        (_ctx.showRawHtml)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                    _cache[45] || (_cache[45] = _createElementVNode("span", null, "ÉDITION HTML DIRECTE", -1)),
                                    _createElementVNode("button", {
                                        class: "btn-sync-raw",
                                        onClick: _cache[19] || (_cache[19] =
                                            //@ts-ignore
                                            (...args) => (_ctx.syncFromRaw && _ctx.syncFromRaw(...args)))
                                    }, "Appliquer au visuel")
                                ]),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.form.body_html) = $event)),
                                    class: "raw-textarea",
                                    placeholder: "Collez votre code HTML ici...",
                                    spellcheck: "false"
                                }, null, 512), [
                                    [_vModelText, _ctx.form.body_html]
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                        _cache[46] || (_cache[46] = _createElementVNode("span", { class: "preview-label" }, "👁️ Aperçu Gmail", -1)),
                        _createElementVNode("button", {
                            class: "btn-refresh-preview",
                            onClick: _cache[21] || (_cache[21] =
                                //@ts-ignore
                                (...args) => (_ctx.refreshPreview && _ctx.refreshPreview(...args))),
                            disabled: _ctx.isLoadingPreview
                        }, _toDisplayString(_ctx.isLoadingPreview ? '⌛' : '🔄') + " Actualiser ", 9, _hoisted_52)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                        _cache[51] || (_cache[51] = _createStaticVNode("<div class=\"gmail-topbar\" data-v-2128f14c><div class=\"gmail-dot red\" data-v-2128f14c></div><div class=\"gmail-dot yellow\" data-v-2128f14c></div><div class=\"gmail-dot green\" data-v-2128f14c></div><span class=\"gmail-label\" data-v-2128f14c>Gmail</span></div>", 1)),
                        _createElementVNode("div", _hoisted_54, [
                            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "gmail-from" }, [
                                _createTextVNode("De : "),
                                _createElementVNode("strong", null, "Va Bene <noreply@vabenepizza.ch>")
                            ], -1)),
                            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "gmail-to" }, "À : client@exemple.com", -1)),
                            _createElementVNode("div", _hoisted_55, [
                                _cache[47] || (_cache[47] = _createTextVNode("Objet : ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.form.subject || '(sans objet)'), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                            (_ctx.previewHtml)
                                ? (_openBlock(), _createElementBlock("iframe", {
                                    key: 0,
                                    class: "gmail-body-iframe",
                                    srcdoc: _ctx.previewHtml,
                                    frameborder: "0",
                                    sandbox: "allow-same-origin"
                                }, null, 8, _hoisted_57))
                                : (_openBlock(), _createElementBlock("div", _hoisted_58, [...(_cache[50] || (_cache[50] = [
                                        _createElementVNode("span", null, "Cliquez sur \"Actualiser\" pour voir l'aperçu", -1)
                                    ]))]))
                        ])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                    (!_ctx.showResetConfirm)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-reset",
                            onClick: _cache[22] || (_cache[22] = ($event) => (_ctx.showResetConfirm = true)),
                            title: "Réinitialiser au template statique"
                        }, " 🗑️ Réinitialiser "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _cache[52] || (_cache[52] = _createElementVNode("span", { class: "confirm-link" }, "Sûr ?", -1)),
                            _createElementVNode("button", {
                                class: "btn-reset-yes",
                                onClick: _cache[23] || (_cache[23] =
                                    //@ts-ignore
                                    (...args) => (_ctx.resetToDefault && _ctx.resetToDefault(...args)))
                            }, "OUI"),
                            _createElementVNode("button", {
                                class: "btn-reset-no",
                                onClick: _cache[24] || (_cache[24] = ($event) => (_ctx.showResetConfirm = false))
                            }, "NON")
                        ]))
                ]),
                _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("button", {
                        class: "btn-cancel",
                        onClick: _cache[25] || (_cache[25] = ($event) => (_ctx.$emit('close')))
                    }, "Annuler"),
                    _createElementVNode("button", {
                        class: "btn-preview",
                        onClick: _cache[26] || (_cache[26] =
                            //@ts-ignore
                            (...args) => (_ctx.refreshPreview && _ctx.refreshPreview(...args))),
                        disabled: _ctx.isLoadingPreview
                    }, _toDisplayString(_ctx.isLoadingPreview ? '⌛ Chargement...' : '👁️ Prévisualiser'), 9, _hoisted_63),
                    _createElementVNode("button", {
                        class: "btn-save",
                        onClick: _cache[27] || (_cache[27] =
                            //@ts-ignore
                            (...args) => (_ctx.saveTemplate && _ctx.saveTemplate(...args))),
                        disabled: _ctx.isSaving
                    }, [
                        (_ctx.isSaving)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.isSaving ? 'Enregistrement...' : '💾 Enregistrer'), 1)
                    ], 8, _hoisted_64)
                ])
            ])
        ])
    ]));
}
